import React from "react";
import "./Dashbord.css";
import { MDBBtn, MDBRow, MDBCol, MDBCard, MDBProgress, MDBProgressBar, MDBCardText, MDBCardBody, MDBCardHeader } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
import Level from "../../../assets/images/A1.png";
import { Player } from "video-react";
const Dashbord = () => {
  const navigate = useNavigate();
  return (
    <div className="Dashbord">
      <MDBRow className="row-cols-1 row-cols-md-2 g-4">
        <MDBCol>
          <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
            <MDBCardHeader>درصد پیشرفت</MDBCardHeader>
            <MDBCardBody>
              <MDBCardText>
                <MDBProgress height="30">
                  <MDBProgressBar width="80" valuemin={0} valuemax={100}>
                    80%
                  </MDBProgressBar>
                </MDBProgress>
              </MDBCardText>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        <MDBCol>
          <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
            <MDBCardHeader>سطح زبان آموز</MDBCardHeader>
            <MDBCardBody>
              <MDBCardText>
                <img className="IMG" src={Level} />
              </MDBCardText>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        {/* <MDBCol>
          <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
            <MDBCardHeader>بخش لغات</MDBCardHeader>
            <MDBCardBody>
              <MDBCardText>
                <MDBBtn rounded color="success" onClick={() => navigate("/Words")}>
                  ورود به بخش لغات
                </MDBBtn>
              </MDBCardText>
            </MDBCardBody>
          </MDBCard>
        </MDBCol> */}
        <MDBCol>
          <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
            <MDBCardHeader>بخش گرامر</MDBCardHeader>
            <MDBCardBody>
              <MDBCardText>
                <MDBBtn rounded color="success" onClick={() => navigate("/Grammer")}>
                  ورود به بخش گرامر
                </MDBBtn>
              </MDBCardText>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        <MDBCol>
          <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
            <MDBCardHeader>ویدئوها</MDBCardHeader>
            <MDBCardBody>
              <MDBCardText>
                <MDBBtn rounded color="success" onClick={() => navigate("/")}>
                  ورود به بخش ویدئوها
                </MDBBtn>
              </MDBCardText>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        <MDBCol>
          <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
            <MDBCardHeader>سابقه آزمون</MDBCardHeader>
            <MDBCardBody>
              <MDBCardText>آزمون های داده شده : 2 عدد</MDBCardText>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        <MDBCol>
          <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
            <MDBCardHeader>آزمون</MDBCardHeader>
            <MDBCardBody>
              <MDBCardText>A2 آزمون اتمام سطح</MDBCardText>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>

      {/* <Player src="https://zabanamooz.herokuapp.com/media/%DA%A9%D9%84%DB%8C%D9%BE_%DA%A9%D9%88%D8%AA%D8%A7%D9%87_%D9%88%D9%84%D9%86%D8%AA%D8%A7%DB%8C%D9%86_%D9%85%D8%A8%D8%A7%D8%B1%DA%A9_-_%D8%B9%D8%B4%D9%82%D9%85_%D9%88%D8%B6%D8%B9%DB%8C%D8%AA_%D9%88%D8%A7%D8%AA%D8%B3%D8%A7%D9%BE_auto.mp4" /> */}
    </div>
  );
};

export default Dashbord;
